import type { ReactNode } from 'react'
import type { ChatSearchHighlight } from 'tripPlanner/api/types'

/** `highlights` are svc-trip's sorted, merged UTF-16 ranges into `text`, with an exclusive end. */
export function highlightChatSearchMatches(text: string, highlights: ReadonlyArray<ChatSearchHighlight>): Array<ReactNode> {
  const parts: Array<ReactNode> = []
  let cursor = 0

  for (const { start, end } of highlights) {
    if (start > cursor) {
      parts.push(text.slice(cursor, start))
    }
    parts.push(<strong key={start}>{text.slice(start, end)}</strong>)
    cursor = end
  }

  if (cursor < text.length) {
    parts.push(text.slice(cursor))
  }

  return parts
}
